//生成本地临时路径兼容写法
export const createObjectUrl = (file) => {
  let url = null ;
  if (window.createObjectURL != undefined) { // basic
    url = window.createObjectURL(file);
  } else if (window.webkitURL != undefined) { // webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  } else if (window.URL != undefined) { // mozilla(firefox)
    url = window.URL.createObjectURL(file);
  }
  return url ;
}

//给定时间对象,输出
//格式以后再改活,先写死
// yyyy-mm-dd hh-mm
export const timeObjformat = (obj) => {
  let y = obj.getFullYear();
  let m = obj.getMonth() + 1;
  let d = obj.getDate();
  let h = obj.getHours();
  let min = obj.getMinutes();
  return `${y}-${buwei(m)}-${buwei(d)} ${buwei(h)}:${buwei(min)}`
}


export const setgoindex = () => {
  if (window.history.length <= 1) {
    if (location.href.indexOf('?') === -1) {
      window.location.href = location.href + '?goindex=true'
    } else if (location.href.indexOf('?') !== -1 && location.href.indexOf('goindex') === -1) {
      window.location.href = location.href + '&goindex=true'
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/utils.js